"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnexpectedEmptyBotPasswordError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const errorCode = "UnexpectedEmptyBotPassword";
const messageKey = "driver.botAadApp.error.unexpectedEmptyBotPassword";
class UnexpectedEmptyBotPasswordError extends teamsfx_api_1.UserError {
    constructor(actionName, helpLink) {
        super({
            source: actionName,
            name: errorCode,
            message: localizeUtils_1.getDefaultString(messageKey, actionName),
            displayMessage: localizeUtils_1.getLocalizedString(messageKey, actionName),
            helpLink: helpLink,
        });
    }
}
exports.UnexpectedEmptyBotPasswordError = UnexpectedEmptyBotPasswordError;
//# sourceMappingURL=unexpectedEmptyBotPasswordError.js.map